<template>
  <div class="container-fluid p-0">
    <div class="card mb-3" v-if="!!vesselResponse">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <span class="h5 text-danger font-weight-bold text-uppercase">Company Instruction</span>
          </div>
        </div>
        <hr style="border-bottom: 2px solid #b5b5b5">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Original Report : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <button class="btn btn-sm e-btn-blue text-uppercase" @click="showReportOrInspectionNewTab(vesselResponse)">
              {{ this.vesselResponse.report?.title ?? this.vesselResponse?.report?.code }}
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Report Number : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <template v-if="!!vesselResponse.report">
              <input type="text" class="form-control form-control-sm"
                     disabled
                     :value="vesselResponse.report.code | toUpper"
                     name="report-number"
                     id="report-number">
            </template>

          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Instruction : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <template v-if="!!vesselResponse.instruction">
              <input type="text" class="form-control form-control-sm"
                     disabled
                     :value="vesselResponse.instruction.title | toUpper"
                     name="instruction-title"
                     id="instruction-title">
            </template>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Type of Instruction : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <template v-if="!!vesselResponse.instruction">
              <input type="text" class="form-control form-control-sm"
                     disabled
                     :value="vesselResponse.instruction.instruction_type | toUpper"
                     name="instruction_title"
                     id="instruction_title">
            </template>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Related Parties : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <template v-if="!!vesselResponse.instruction">
              <input type="text" class="form-control form-control-sm"
                     disabled
                     :value="vesselResponse.instruction.related_party | toUpper"
                     name="instruction_title"
                     id="instruction_title">
            </template>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Instruction Detail : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
            <div class="card w-100" style="background: #e9ecef;">
              <div class="card-body">
                <div v-html="vesselResponse?.instruction?.detail" class="pre-wrap-txt">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Instruction Attachments : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <div class="row">
              <div class="col-lg-2 col-md-2 col-sm-12" v-for="attachment in instructionFiles">
                <other-comp :no-delete="true"
                            @viewOther="viewInstructionAttachment(attachment,false)"
                            :attachment="attachment" attachment-name="name" class="p-3"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Job Done : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <vue-editor :editor-toolbar="toolbar" v-model="vesselResponse.response"></vue-editor>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Attachments : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <div class="row justify-content-start mr-1 mb-2 mt-1" >
              <template v-if="!isEditAttachments">
                <div :class="{ 'ml-2' : documentAttachments.length === 0 } " class="p-2">
                  {{ documentAttachments.length > 0 ? '' : '(No uploaded file(s) yet)'}}
                </div>
                <button class="e-btn e-btn-green" @click="addEditAttachments" id="addBtn" type="button">{{ documentAttachments.length > 0 ? 'Edit Attachments' : 'Add Attachments'}}</button>
              </template>
              <template v-else >
                <div class="ml-2">
                  <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelEditAttachment">Cancel</button>
                  <button class="e-btn e-btn-blue ml-2" type="submit" @click.prevent="saveAttachments" :class="is_attachments_change === false ? 'e-btn-blue-disabled' : ''" :disabled="is_attachments_change === false">Save</button>
                </div>
              </template>
            </div>
            <attachments-handler
              ref="ci-documents-handler"
              :accepted-file-types="mimes"
              :current-attachments="documentAttachments"
              :edit-mode="isEditAttachments"
              :viewing-permission="true"
              :deleting-permission="true"
              :changes_id="'is_attachments_change'"
              @attachment-has-changes="setButtonChange"
              :max-height="500"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Job Status : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <select class="form-control form-control-sm" v-model="vesselResponse.job_status_id">
              <option :value="status.id" v-for="status in jobStatuses" >
                {{status.name | toUpper}}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Acknowledgement Status : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <select class="form-control form-control-sm" disabled v-model="vesselResponse.acknowledgement_status_id">
              <option :value="status.id" v-for="status in acknowledgementStatuses" v-model="vesselResponse.acknowledgement_status_id">
                {{status.name | toUpper}}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-3 col-md-3 col-sm-12 d-flex align-items-center mt-2">
            <span class="h6 font-weight-bold text-uppercase">Comments : </span>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <div class="row">
              <div class="col-12">
                <template v-if="!!vesselResponse">
                  <CIComment :key="vesselResponse.id" :vessel-response="vesselResponse" v-if="!!vesselResponse.id" :ciVesselId="vesselResponse.id"></CIComment>
                </template>
              </div>
            </div>
          </div>
        </div>
        <hr style="border-bottom: 2px solid #b5b5b5" v-show="isVesselResponseModified">
        <div class="row" v-show="isVesselResponseModified">
          <div class="col-lg-12 col-md-12 col-sm-12 d-flex align-items-center justify-content-end">
            <button type="button" class="btn e-btn-green" @click="submitResponse">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OtherComp from "@/components/elements/OtherComp.vue";
import {CI_INDEX, CI_VESSEL_INDEX} from "@/services/ConstantService";
import axios from "axios";
import {FileService} from "@/services/FileService";
import {AlertService} from "@/services/AlertService";
import CIComment from "@/components/modules/ci/CIComment.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
import ObjectMixin from "@/mixins/ObjectMixin";
import vessel from "@/views/Vessel.vue";
import AttachmentsHandler from "@/components/common/AttachmentsHandler.vue";

export default {
  name: "VesselCompanyInstructionResponse",
  components: {AttachmentsHandler, CIComment, OtherComp},
  mixins:[permissionMixin,ObjectMixin],

  data(){
    return{
      vesselResponse : {},
      isEditAttachments:false,
      addAttachment:false,
      is_attachments_change : false,
      tempResponse:{},
      isVesselResponseModified:false,
      toolbar:[
        ['bold','italic','strike','underline'],
        [{'color':["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]}]
      ],
      mimes: [
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/zip',
        'application/octet-stream',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'image/apng',
        'image/avif',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'image/webp',
        'image/jpg',
        'image/tiff'
      ],
      resourceLoadingText : '',
    }
  },

  computed:{
    ...mapGetters(['instructionFiles','instructionAttachments','jobStatuses','acknowledgementStatuses']),
    documentAttachments() {
      return Object.entries(this.instructionAttachments).map(([key, document]) => {
        return {
          source : document.path,
          options : {
            type : 'local',
            file : {
              name : document.name,
              type : document.mime_type,
              size: parseFloat(document.file_size.replace(/[^0-9.,]/g, '').replace(/,/g, '')) * 1000
            },
            metadata : {
              id : document.id,
              referencable_id : document.referencable_id,
              thumbnail : document.thumbnail,
              file_size : document.file_size,
              created_at : document.created_at,
              view_attachment_method : () => this.viewInstructionAttachment(document)
            }
          }
        }
      })
    },
  },

  methods: {
    ...mapActions(['getVesselResponse', 'getVesselAttachments', 'getAcknowledgementStatuses', 'getJobStatuses','addNewVesselAttachments','deleteVesselAttachment','sendVesselResponse', 'getCompanyInstructionAttachments']),
    async viewInstructionAttachment(attachment, fromVessel = true) {
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();

      const mainRoute = fromVessel ? CI_VESSEL_INDEX : CI_INDEX

      const url = [mainRoute, attachment.referencable_id, 'attachment', attachment.id].join('/')

      const response = await axios.get(url, {responseType: 'blob'})

      if (response && response.status == 200) {
        if (attachment.extension === 'pdf' || attachment.mime_type.includes("image")) {
          await FileService.viewDocument(response.data, attachment)
        } else {
          await FileService.downloadDocument(response.data, attachment, 'name');
        }
        swal.close();
      } else {
        AlertService.errorAlert('File not exists', "View Attachment")
      }
    },
    async deleteInstructionAttachment(attachment) {
      if (await AlertService.confirmDeleteAlert('Delete Company Instruction Attachment', 'Do you want to delete this attachment ?', 'Yes, proceed')) {
        const response = await this.deleteVesselAttachment({id:this.vesselResponse.id,attachment_id:attachment.id});
        if (response) {
          AlertService.successAlert('Company Instruction Attachment has been deleted successfully', 'Delete Company Instruction Attachment');
        }
      }
    },
    async cancelAddAttachment() {
      if (await AlertService.cancelAlert()) {
        this.addAttachment = false;
      }
    },
    async saveAttachments(){
      if (this.$refs["ci-documents-handler"].isProcessingFiles() === true) {
        return AlertService.warningAlert(`Please wait for the attachments to finish processing`, 'ATTACHMENTS PROCESSING');
      }

      const filesHasError = this.$refs["ci-documents-handler"].filesHasError();
      if (filesHasError) {
        return;
      }

      swal.fire({
        'title':`Updating Attachments <br> Please wait.....`
      })

      swal.showLoading();

      // saving of files process
      const files = this.$refs["ci-documents-handler"].getValidFilesUniqueIds();

      if (files.length > 0) {
        let formData = new FormData();
        Array.prototype.forEach.call(files, file => {
          formData.append('file_unique_ids[]', file);
        })

        formData.append('id',this.$route.query.id);
        await this.addNewVesselAttachments(formData)
      }

      const filesToRemove = this.$refs["ci-documents-handler"].getFilesToRemove();
      // deletion of files process
      this.$refs["ci-documents-handler"].resetValues();
      await this.deleteAllAttachments(filesToRemove);

      await this.getVesselAttachments({id: this.$route.query.id})
      swal.close();
      await AlertService.successAlert(`Attachments updated successfully`, 'UPLOAD ATTACHMENTS');
      this.isEditAttachments = false;
    },
    async deleteAllAttachments(filesToRemove, counter = 0) {
      if (filesToRemove.length === 0) {
        return;
      }
      await this.deleteVesselAttachment({
        id : filesToRemove[counter].referencable_id,
        attachment_id : filesToRemove[counter].id
      });
      counter++;
      if (counter < filesToRemove.length) {
        await this.deleteAllAttachments(filesToRemove, counter);
      }
    },
    async submitResponse() {
      if(await AlertService.confirmUpdateAlert('Do you want to update your response ? ')){
        const params={
          id:this.vesselResponse.id,
          job_status_id:this.vesselResponse.job_status_id,
          response:this.vesselResponse.response
        }
        const response = await this.sendVesselResponse(params)
        if(response){
          AlertService.successAlert('Response Updated Successfully','Submit Response');
          this.isVesselResponseModified=false;
          this.vesselResponse=await this.getVesselResponse({id: this.$route.query.id});
          this.tempResponse=Object.assign({},this.vesselResponse)
        }
      }
    },
    getReportRouteTo(reportFrom) {
      if (reportFrom === 'AccidentIncident') {
        return 'AirCompanyInstruction';
      }
      if (reportFrom === 'Deficiency') {
        return 'PscDeficiency';
      }
      if (reportFrom === 'NonConformity') {
        return 'RsNonConformity';
      }

      return 'IaCompanyInstructions'
    },
    getRouteParams(vesselResponse) {
      if (vesselResponse.report_from !== 'ObjectiveEvidence') {
        return {
          id: vesselResponse.report.id,
        }
      }

      return {
        vessel_id : vesselResponse?.report?.vessel_id,
        id        : vesselResponse?.report?.internal_audit_id,
        type      : vesselResponse?.report?.audit_type,
        ncr_id    : vesselResponse?.report?.non_conformity_id,
        ncr_type  : vesselResponse?.report?.non_conformity_type,
        oe_id     : vesselResponse?.report?.oe_id,
      };
    },
    getRouteQuery(vesselResponse) {
      if (vesselResponse.report_from !== 'ObjectiveEvidence') {
        return {
          def_id: vesselResponse.instruction.taggable_deficiency_id,
        }
      }

      return {};
    },
    async showReportOrInspectionNewTab (vesselResponse) {
      const route = this.$router.resolve(
        {
          name: this.getReportRouteTo(vesselResponse.report_from),
          params: this.getRouteParams(vesselResponse),
          query: this.getRouteQuery(vesselResponse)
        },
      )
      window.open(route.href,'_blank')
    },
    setButtonChange(changeId, hasChanges) {
      this[changeId] = hasChanges;
    },
    addEditAttachments() {
      this.isEditAttachments = !this.isEditAttachments;
      this.$refs["ci-documents-handler"].resetValues();
    },
    async cancelEditAttachment(){
      if (this.is_attachments_change === false) {
        this.$refs["ci-documents-handler"].resetValues();
        this.isEditAttachments=false;
      } else {
        if(await AlertService.cancelAlert()) {
          this.$refs["ci-documents-handler"].resetValues();
          this.is_attachments_change = false;
          this.isEditAttachments=false;
        }
      }
    },
  },

  async created() {
    swal.fire({
      title: 'LOADING RESOURCES',
      text: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: async () => {
        swal.showLoading();
        const response = await this.getVesselResponse({ id: this.$route.query.id });
        if (response) {
          swal.update(
            {
              title: 'FETCHING VESSEL ATTACHMENTS',
            });

          await this.getVesselAttachments({ id: this.$route.query.id });
          this.vesselResponse = Object.assign({}, response);
          this.tempResponse = Object.assign({}, response);

          swal.update(
            {
              title: 'FETCHING COMPANY INSTRUCTION ATTACHMENTS',
            });


          await this.getCompanyInstructionAttachments({ id: this.vesselResponse.instruction.id });
          await this.getJobStatuses();
          await this.getAcknowledgementStatuses();

          swal.close()
        }
      }
    });


  },
  watch:{
    'vesselResponse.job_status_id'(){
      this.isVesselResponseModified=this.dataDiff(this?.tempResponse ?? null,this.vesselResponse ?? null)
    },
    'vesselResponse.response'(){
      this.isVesselResponseModified=this.dataDiff(this?.tempResponse ?? null,this.vesselResponse ?? null)
    }
  }
}
</script>

<style scoped>

</style>
